
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-guarantee-agreement",
      function () {
        return require("private-next-pages/health-guarantee-agreement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-guarantee-agreement"])
      });
    }
  